import { CurledText, Mail, MoreHorizontal, Phone, Truck, User } from "@/components/icons_new";
import { useOrderDetailsContext } from "../context/OrderDetailsContext";

const formatAddress = (address) => {
  if (!address) return ["Address unavailable"];
  const lines = [address.name, address.addressLine1];
  if (address.addressLine2) lines.push(address.addressLine2);
  const cityLine = [address.city, address.zipCode].filter(Boolean).join(" ");
  if (cityLine) lines.push(cityLine);
  if (address.country) lines.push(address.country);
  return lines.filter((line) => line && line.trim().length > 0);
};

export default function OrderCustomerInfo() {
  const { order } = useOrderDetailsContext();

  if (!order) return null;

  const billingAddressLines = formatAddress(order.billingAddress);
  const shippingAddressLines = formatAddress(order.shippingAddress);

  return (
    <div className="flex flex-col space-y-2 rounded-md border bg-white py-2">
      <div className="flex items-center justify-between px-4 pt-2">
        <span className="text-[17px] font-semibold text-[#333333]">Customer</span>
      </div>

      <div className="flex items-center gap-[0.7em] border-b border-[#c9c9c9] px-4 pb-3">
        <User className="h-4 w-4 text-[#333333b1]"/>
        <span className="block text-sm font-medium text-[#333333]">
          {order.customer.name || "Unknown customer"}
        </span>
      </div>

      <div className="flex flex-col gap-[1em] border-b border-[#c9c9c9] px-4 py-3 text-sm">
        <div className="flex items-center gap-[10px]">
          <Mail className="h-4 w-4 text-[#333333b1]"/>
          {order.customer.email ? (
            <a
              className="text-[#333333] text-sm font-medium hover:underline"
              href={`mailto:${order.customer.email}`}
            >
              {order.customer.email}
            </a>
          ) : (
            <span className="text-[#9ca3af] text-sm font-medium italic">No email provided</span>
          )}
        </div>
        
        <div className="flex items-center gap-[10px]">
          <Phone className="h-4 w-4 text-[#333333b1]"/>
          {order.customer.phone ? (
            <a className="text-[#333333] text-sm font-medium hover:underline" href={`tel:${order.customer.phone}`}>
              {order.customer.phone}
            </a>
          ) : (
            <span className="text-[#9ca3af] text-sm font-medium italic">No telephone provided</span>
          )}
        </div>
      </div>

      <div className="flex flex-col gap-2 border-b border-[#c9c9c9] px-4 py-3 text-sm">
        <div className="flex items-center gap-[10px]">
          <CurledText className="h-4 w-4 text-[#333333b1]"/>
          <span className="font-medium text-[#333333]">Billing Address</span>
        </div>
        
        <div className="text-[#333333] ml-[25px]">
          {billingAddressLines.map((line, index) => (
            <p key={index}>{line}</p>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-2 px-4 py-3 text-sm">
        <div className="flex items-center gap-[10px]">
          <Truck className="h-4 w-4 text-[#333333b1]"/>
          <span className="font-medium text-[#333333]">Shipping Address</span>
        </div>
        
        <div className="text-[#333333] ml-[25px]">
          {shippingAddressLines.map((line, index) => (
            <p key={index}>{line}</p>
          ))}
        </div>
      </div>
    </div>
  );
}
